/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

export const ACTIVITY_TYPES = {
    ASSIGNED_ISSUES_READ: 'ASSIGNED_ISSUES_READ',
    ASSIGNED_ISSUES_WRITE: 'ASSIGNED_ISSUES_WRITE',
    ALL_ISSUES_READ: 'ALL_ISSUES_READ',
    ALL_ISSUES_WRITE: 'ALL_ISSUES_WRITE',
    FLEETS_READ: 'FLEETS_READ',
    FLEETS_WRITE: 'FLEETS_WRITE',
    USERS_READ: 'USERS_READ',
    USERS_WRITE: 'USERS_WRITE',
    CONFIG_READ: 'CONFIG_READ',
    CONFIG_WRITE: 'CONFIG_WRITE',
    TASKS_READ: 'TASKS_READ',
    TASKS_WRITE: 'TASKS_WRITE',
    CONFIG_SYMPTOMS_WRITE: 'CONFIG_SYMPTOMS_WRITE',
    HDA_FUNCTIONALITIES: 'HDA_FUNCTIONALITIES',
    ASSETS_READ: 'ASSETS_READ',
    ASSETS_WRITE: 'ASSETS_WRITE',
    EXTERNAL_ACTIVITY: 'EXTERNAL_ACTIVITY',
    UI_CONFIG_WRITE: 'UI_CONFIG_WRITE',
}

export const ROLES = {
    WORKER: 'WORKER',
    FLEET_MANAGER: 'FLEET_MANAGER',
    ADMIN: 'ADMIN',
    OBSERVER: 'OBSERVER',
    ADVANCED_WORKER: 'ADVANCED_WORKER',
    HDA_MECHANIC: 'HDA_MECHANIC',
    HDA_ADMIN: 'HDA_ADMIN',
    AIRTIME_GENERIC: 'AIRTIME_GENERIC',
    UI_CONFIG_ADMIN: 'UI_CONFIG_ADMIN',
}